
define('text!modules/creatives/templates/infobox.html',[],function () { return '<div class="info-box {{ type }} {{ cssClasses }}">\n  <i class="icon"></i>\n  <div class="message">{{{message}}}</div>\n</div>\n';});

